import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
interface TrustRowProps {
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}
const ITEMS = [{
  Icon: LockIcon,
  label: 'Secure checkout'
}, {
  Icon: ZapIcon,
  label: 'Instant download'
}, {
  Icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function TrustRow({
  tone = 'light',
  align = 'left',
  className = ''
}: TrustRowProps) {
  const text = tone === 'dark' ? 'text-paper/60' : 'text-slate';
  return <ul className={['flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-[11px] uppercase tracking-label', text, align === 'center' ? 'justify-center' : '', className].join(' ')} data-id="element-234" data-mp="1k1s6spgxydi4">
      {ITEMS.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5" data-id="element-235" data-mp="3acddaq7gfmbb">
          <Icon className="h-3.5 w-3.5 text-brass" aria-hidden="true" strokeWidth={2} data-id="element-236" data-mp="3aezkgoqfnzt0" />
          {label}
        </li>)}
    </ul>;
}